// The expert portal for an expert no organisation has added to a project yet
// (no engagement: signed up without an invitation code). Every portal API
// answers 404 for them, which read "Page not found"; PortalShell shows this
// instead, on every portal page but Help.
import { useMeta } from "../api/meta";
import { PageHeader } from "../ui/PageHeader";

export function NoPortalWork({ name }: { name: string }) {
  const meta = useMeta();
  const first = name.trim().split(/\s+/)[0] || name;
  return (
    <>
      <PageHeader title={`Welcome, ${first}`} documentTitle="Expert portal" lead="Your account is ready." />
      <p>You have no work here yet. When an organisation adds you to one of its projects, your assignments, hours, invoices and contracts show here.</p>
      <p>
        Expecting to see a project? Ask the organisation to send you an invitation to the portal, or write to{" "}
        <a href={`mailto:${meta.supportEmail}`}>{meta.supportEmail}</a>.
      </p>
    </>
  );
}
